export const getSpacingValue = (spacing) => parseInt(spacing.replace('px', ''), 10);
export const getSpacingStyle = (topOrAll, right, bottom, left) => [topOrAll, right, bottom, left].join(' ').trim();
//# sourceMappingURL=spacing.js.map